import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=2b74d434&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CookieBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Button/Btn.vue').default,Wrapper: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Layout/Wrapper.vue').default,Icon: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Icon/Icon.vue').default})
